import { Divider, IconButton, Popover, useToggle } from "@evergis/ui";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { css } from "styled-components";
import { Filters } from "../TopBar/Filters";
import { FiltersCollapsedContainer, FiltersCollapsedContentContainer } from "./styled";
import { FilterContainerProps } from "./types";

const CONTENT_MIXIN = css`
  bottom: 0 !important;
  left: 0 !important;
  transform: translate(-50%, calc(-100% + 0.5rem)) scale(1, 1) !important;
`;

export const FiltersCollapsed: FC<FilterContainerProps> = ({ breakpoint, alwaysShow, className, children }) => {
  const { t } = useTranslation("catalog");
  const [open, toggleOpen] = useToggle(false);

  return (
    <FiltersCollapsedContainer breakpoint={breakpoint} alwaysShow={alwaysShow}>
      <Popover
        anchor={<IconButton title={t("filters")} kind="filter" primary={open} onClick={toggleOpen} />}
        autoPosition={false}
        anchorOrigin={"bottom"}
        targetOrigin={"bottom"}
        open={open}
        onRequestClose={toggleOpen}
        mixin={CONTENT_MIXIN}
        zIndex={119}
        closeOnScroll={false}
      >
        <FiltersCollapsedContentContainer className={className}>
          {children || <Filters />}
        </FiltersCollapsedContentContainer>
      </Popover>
      <Divider style={{ marginRight: "0.5rem" }} vertical />
    </FiltersCollapsedContainer>
  );
};
